import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-login-help',
  templateUrl: './login-help.component.html',
  standalone: true,
  imports: [],
})
export class LoginHelpComponent {
  constructor(public modalRef: BsModalRef) {}
}
